import { Fragment } from 'react';
import Form from 'components/Form';
import { IFormValues, IFormRegister } from 'routes/Main/type';
import { Stack } from '@mui/material';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';
import SectionTitle from '../../components/SectionTitle';
import MuiRadioGroup from './components/MuiRadioGroup';
import CheckboxGroup from './components/CheckboxTwo';

interface Props extends IFormValues, IFormRegister {
  disabled?: boolean;
}

const Accident = (props: Props) => {
  const { disabled, getValues, setValue, register } = props;

  return (
    <Fragment>
      <SectionTitle title="사고" />

      <RowContainer xs={12}>
        <RowContent
          title="사고형태 및 과정"
          titleRatio={1.2}
          childrenRatio={10.8}
        >
          <Stack direction="row" spacing={3}>
            <MuiRadioGroup
              i18nKey="MOOD.RADIO"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('accident.type_and_course.value')}
              onChange={v => {
                setValue('accident.type_and_course.value', v);
              }}
            />
          </Stack>
        </RowContent>

        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <Stack
            direction="column"
            spacing={1}
            sx={{
              border: '1px solid #c0bebed4',
              borderRadius: '7px',
              marginTop: '-50px',
              padding: '8px',
            }}
          >
            <CheckboxGroup
              i18nNullKey="ETC"
              i18nKey="THOUGHT.CHECKBOX.ONE"
              values={[1, 2, 3, 4, 5, 6]}
              disabled={disabled}
              defaultValue={getValues('accident.type_and_course.checked')}
              onChange={v => setValue('accident.type_and_course.checked', v)}
            />
            <CheckboxGroup
              i18nNullKey="ETC"
              i18nKey="THOUGHT.CHECKBOX.ONE"
              values={[7, 8, 9, 10]}
              disabled={disabled}
              defaultValue={getValues('accident.type_and_course_two.checked')}
              onChange={v =>
                setValue('accident.type_and_course_two.checked', v)
              }
            />
          </Stack>
        </RowContent>
        <RowContent
          title="사고 내용"
          titleRatio={2.65}
          childrenRatio={8.2}
        ></RowContent>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <Stack
            direction="column"
            spacing={1}
            sx={{
              border: '1px solid #c0bebed4',
              borderRadius: '7px',
              padding: '8px',
            }}
          >
            <CheckboxGroup
              i18nNullKey="ETC"
              i18nKey="THOUGHT.CHECKBOX.TWO"
              values={[1, 2, 3, 4, 5, 6]}
              disabled={disabled}
              defaultValue={getValues('accident.detail1.checked')}
              onChange={v => setValue('accident.detail1.checked', v)}
            />
            <CheckboxGroup
              i18nNullKey="ETC"
              i18nKey="THOUGHT.CHECKBOX.TWO"
              values={[7, 8, 9, 10, 11]}
              disabled={disabled}
              defaultValue={getValues('accident.detail1_two.checked')}
              onChange={v => setValue('accident.detail1_two.checked', v)}
            />
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <Stack
            direction="column"
            spacing={1}
            sx={{
              border: '1px solid #c0bebed4',
              borderRadius: '7px',
              marginTop: '-50px',
              padding: '8px',
            }}
          >
            <CheckboxGroup
              i18nNullKey="ETC"
              i18nKey="THOUGHT.CHECKBOX.THREE"
              values={[1, 2, 3, 4, 5]}
              disabled={disabled}
              defaultValue={getValues('accident.detail2.checked')}
              onChange={v => setValue('accident.detail2.checked', v)}
            />
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <Stack
            direction="column"
            spacing={1}
            sx={{
              border: '1px solid #c0bebed4',
              borderRadius: '7px',
              marginTop: '-50px',
              padding: '8px',
            }}
          >
            <CheckboxGroup
              i18nNullKey="ETC"
              i18nKey="THOUGHT.CHECKBOX.FOUR"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('accident.detail3.checked')}
              onChange={v => setValue('accident.detail3.checked', v)}
            />
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <Stack
            direction="row"
            spacing={1}
            sx={{
              border: '1px solid #c0bebed4',
              borderRadius: '7px',
              marginTop: '-50px',
              padding: '8px',
            }}
          >
            <CheckboxGroup
              i18nNullKey="ETC"
              i18nKey="THOUGHT.CHECKBOX.FOUR"
              values={[0]}
              disabled={disabled}
              defaultValue={getValues('accident.detail4.checked')}
              onChange={v => setValue('accident.detail4.checked', v)}
            />
            <Form.MuiTextField
              disabled={disabled}
              required={false}
              fullWidth
              placeholder="구체적인 설명을 적어주세요."
              {...register('accident.detail4.input')}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Accident;
